import ProfileSetting from '@/Component/Profile/ProfileSetting'
import PrivacyPolicy from '@/Component/Profile/ProfileSetting/PrivacyPolicy'


const PrivacyPolicyPage = () => {
    return (
        <ProfileSetting activeTab="privacy-policy">
            <PrivacyPolicy/>
        </ProfileSetting>
    )
}

export default PrivacyPolicyPage
